import { useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function usePatientAppHome() {
  const fetchAppointments = useCallback(
    () => quarkusApi.get('/patient-app/appointments', authHeader()),
    [],
  );

  const loginWithToken = useCallback(
    (accessToken) =>
      quarkusApi.post(`/patient-app/login/token?token=${encodeURIComponent(accessToken)}`),
    [],
  );

  const confirmAppointment = useCallback(
    (appointmentId) =>
      quarkusApi.post(`/patient-app/appointments/${appointmentId}/confirm`, null, authHeader()),
    [],
  );

  return { fetchAppointments, loginWithToken, confirmAppointment };
}
